import {
  MoreLess,
  type MoreLessHandles,
  type MoreLessProps,
} from '@op/opds.opux';
import { useEffect, useRef } from 'react';

export type MoreLessWCAGProps = MoreLessProps & {
  screenReaderMessages?: { less: string; more: string };
};

export default function MoreLessWCAG(props: MoreLessWCAGProps) {
  const ref = useRef<MoreLessHandles>(null);
  const { screenReaderMessages, ...moreLessProps } = props;

  const setAriaLabel = (n = 0) => {
    if (ref.current === null || !screenReaderMessages) {
      return;
    }
    ref.current.controlRef.current.firstChild.ariaLabel =
      n === 0 ? screenReaderMessages.more : screenReaderMessages.less;
  };

  const onChange = (n: number) => {
    setAriaLabel(n);
    if (props.onChange) {
      props.onChange(n);
    }
  };

  useEffect(setAriaLabel, []);

  return (
    <MoreLess {...moreLessProps} ref={ref} onChange={onChange}>
      {props.children}
    </MoreLess>
  );
}
